export default __webpack_public_path__ + "static/media/hour-glass.d5d73957.svg";